// extracted by mini-css-extract-plugin
module.exports = {"title":"e245e","wrapper":"a8a7c","posts":"b666e","post":"be293"};